import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Scrollbars from 'react-custom-scrollbars';
import CloseIcon from 'react-icons/lib/fa/close';
import Styles from './styles';
import Button from '../UIKit/Button';

const ActionPanel = (props) => {
  // const renderDefaultHeader = () => {};

  // const renderHeader = () => {};

  const closeButton = (
    <Button
      onClick={props.onActionPanelClose}
      size="sm"
      style={[Styles.accessoryButton]}
      buttonStyle={{ color: 'white', marginTop: 0, marginRight: 0, marginBottom: 0, marginLeft: 0 }}
    >
      <CloseIcon size={17} />
    </Button>
  );

  return (
    <div
      style={[
        Styles.wrapper,
        props.wrapperStyle,
        props.isOpen ? { ...Styles.wrapperOpen, ...props.wrapperOpenStyle } : {},
      ]}
    >
      <div style={Styles.header}>
        <span style={Styles.title}>{props.title}</span> {closeButton}
      </div>
      {/* <div style={{ ...Styles.contents, ...props.style }}>{props.children}</div> */}
      <Scrollbars
        style={{ ...Styles.contents }}
        renderTrackVertical={({ style, ...props }) => (
          <div {...props} style={{ ...style, ...Styles.track }} />
        )}
        renderThumbVertical={({ style, ...props }) => (
          <div {...props} style={{ ...style, ...Styles.thumb }} />
        )}
      >
        <div style={{ ...props.style }}>{props.children}</div>
      </Scrollbars>
    </div>
  );
};

ActionPanel.propTypes = {
  style: StylePropType,
  wrapperStyle: StylePropType,
  wrapperOpenStyle: StylePropType,
  title: PropTypes.string,
  renderHeader: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onActionPanelClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

ActionPanel.defaultProps = {
  style: {},
  wrapperStyle: {},
  wrapperOpenStyle: {},
  title: '',
  renderHeader: null,
  children: null,
  onActionPanelClose: () => {},
  isOpen: false,
};

export default Radium(ActionPanel);



// WEBPACK FOOTER //
// ./src/components/ActionPanel/index.js